import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../AppConfig';
import { CommonStyles } from '../styles/Styles';
import { HelmetComponent } from '../common/components/HelmetComponent';
import { Helper } from '../common/helpers/Helper';
import { PageTitleContainer } from '../components/PageTitleContainer';

export class Privacy extends Component {

  renderContent = () => {
    return (
      <Grid container className={css(CommonStyles.textfulPageContent)}>

        <HelmetComponent page={'privacy'} />

        {/* <h2 className={css(CommonStyles.textfulPageTitle)}>Privacy policy</h2> */}

        <h2 className={css(CommonStyles.textfulPageSubtitle)}>What do we do with your information?</h2>
        <p className={css(CommonStyles.textfulPagePara)}>
          When you purchase something from our store, as part of the buying and selling process, we collect the personal information you give us such as your name, address and email address.
        </p>
        <p className={css(CommonStyles.textfulPagePara)}>
          When you browse our store, we also automatically receive your computer’s internet protocol (IP) address in order to provide us with information that helps us learn about your browser and operating system.
        </p>
        <p className={css(CommonStyles.textfulPagePara)}>
          Email marketing (if applicable): With your permission, we may send you emails about our store, new products and other updates.
        </p>

        <h2 className={css(CommonStyles.textfulPageSubtitle)}>Consent</h2>
        <p className={css(CommonStyles.textfulPagePara)}>
          How do you get my consent?
        </p>
        <p className={css(CommonStyles.textfulPagePara)}>
          When you provide us with personal information to complete a transaction, verify your credit card, place an order, arrange for a delivery or return a purchase, we imply that you consent to our collecting it and using it for that specific reason only.
        </p>
        <p className={css(CommonStyles.textfulPagePara)}>
          If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no.
        </p>
        <p className={css(CommonStyles.textfulPagePara)}>
          How do I withdraw my consent?
        </p>
        <p className={css(CommonStyles.textfulPagePara)}>
          If after you opt-in, you change your mind, you may withdraw your consent for us to contact you, for the continued collection, use or disclosure of your information, at anytime, by contacting us.
        </p>

        <h2 className={css(CommonStyles.textfulPageSubtitle)}>Disclosure</h2>
        <p className={css(CommonStyles.textfulPagePara)}>
          We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.
        </p>

        <h2 className={css(CommonStyles.textfulPageSubtitle)}>Payment</h2>
        <p className={css(CommonStyles.textfulPagePara)}>
          We use external payment gateways for processing payments. We do not store your card data on our servers.
        </p>

        <h2 className={css(CommonStyles.textfulPageSubtitle)}>Third-party services</h2>
        <p className={css(CommonStyles.textfulPagePara)}>
          In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us.
        </p>
        <p className={css(CommonStyles.textfulPagePara)}>
          However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions.
        </p>
        <p className={css(CommonStyles.textfulPagePara)}>
          For these providers, we recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled by these providers.
        </p>
        <p className={css(CommonStyles.textfulPagePara)}>
          In particular, remember that certain providers may be located in or have facilities that are located a different jurisdiction than either you or us. So if you elect to proceed with a transaction that involves the services of a third-party service provider, then your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located.
        </p>
        <p className={css(CommonStyles.textfulPagePara)}>
          Once you leave our store’s website or are redirected to a third-party website or application, you are no longer governed by this Privacy Policy or our website’s Terms of Service.
        </p>
        <p className={css(CommonStyles.textfulPagePara)}>
          Links
        </p>
        <p className={css(CommonStyles.textfulPagePara)}>
          When you click on links on our store, they may direct you away from our site. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements.
        </p>

        <h2 className={css(CommonStyles.textfulPageSubtitle)}>Security</h2>
        <p className={css(CommonStyles.textfulPagePara)}>
          To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed.
        </p>

        <h2 className={css(CommonStyles.textfulPageSubtitle)}>Cookies</h2>
        <p className={css(CommonStyles.textfulPagePara)}>
          We use cookies to maintain session of your user. It is not used to personally identify you on other websites.
        </p>

        <h2 className={css(CommonStyles.textfulPageSubtitle)}>Age of consent</h2>
        <p className={css(CommonStyles.textfulPagePara)}>
          By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.
        </p>

        <h2 className={css(CommonStyles.textfulPageSubtitle)}>Changes to this privacy policy</h2>
        <p className={css(CommonStyles.textfulPagePara)}>
          We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it.
        </p>
        <p className={css(CommonStyles.textfulPagePara)}>
          If our store is acquired or merged with another company, your information may be transferred to the new owners so that we may continue to sell products to you.
        </p>

        <h2 className={css(CommonStyles.textfulPageSubtitle)}>Questions and contact information</h2>
        <p className={css(CommonStyles.textfulPagePara)}>
          If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact us.
        </p>

      </Grid>
    )
  }

  render() {
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <PageTitleContainer
          title={Helper.getString('privacy')} />
        <div className={css(CommonStyles.textfulPageContentContainer)}>
          {this.renderContent()}
        </div>
      </div>


    );
  }
}

const Styles = StyleSheet.create({

})
